import { render } from "./simular-pagos.vue?vue&type=template&id=5a273fa2"
import script from "./simular-pagos.vue?vue&type=script&lang=js"
export * from "./simular-pagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__